// Client-side guard for the profile Display Image upload.
//
// The file input's accept="image/jpeg, image/jpg, image/png" attribute is only
// a hint to the native picker — it is trivially bypassed (drag-and-drop, the
// picker's "All files" option) and performs NO validation. Without a real
// check, handleImageChange used to createObjectURL() + open the cropper for
// ANY file: a .txt was accepted as an avatar (broken blob) and a 12 MB file
// sailed straight in with no size gate (SET-AVATAR-NOVALIDATION). This runs the
// actual type/size check before a blob URL or the cropper is created.

export const ACCEPTED_PROFILE_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
];

export const MAX_PROFILE_IMAGE_MB = 5;
export const MAX_PROFILE_IMAGE_BYTES = MAX_PROFILE_IMAGE_MB * 1024 * 1024;

/**
 * @param {File|null|undefined} file
 * @returns {{ ok: boolean, error: string|null }}
 *   ok=false with error=null means "no file" (user cancelled the picker) —
 *   silent, no toast. ok=false with a message means a real rejection.
 */
export function validateProfileImage(file) {
  if (!file) return { ok: false, error: null };

  if (!ACCEPTED_PROFILE_IMAGE_TYPES.includes(file.type)) {
    return { ok: false, error: "Please choose a JPG or PNG image." };
  }

  if (file.size > MAX_PROFILE_IMAGE_BYTES) {
    return {
      ok: false,
      error: `Image is too large. Please choose an image under ${MAX_PROFILE_IMAGE_MB} MB.`,
    };
  }

  return { ok: true, error: null };
}
